<template>
  <template v-if="planStore.loading">
    <h3 class="text-center m-5">
      Loading plan...
    </h3>
  </template>

  <template v-else-if="!frameworks">
    Failed to load plan
  </template>

  <template v-else>
    <PlanDocument :frameworks="frameworks" />
  </template>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { PlanDocument } from '@/components/plan';

import { useHttp } from '@/composables';
import { usePlanStore } from '@/store';

const planStore = usePlanStore();
const route = useRoute();
const router = useRouter();
const frameworks = ref(null);

const loadPlan = async () => {
  const response = await useHttp().get(`/municipalities/${route.params.municipality}/plan`);

  if (response.statusCode === HttpStatusCode.Ok) {
    if (!response.data.isEditable) {
      await router.replace({ name: 'app_plan_overview', params: { municipality: route.params.municipality } });
      return;
    }

    let { id, subtitle, municipality, logo, coverPageImage, mayorPhoto, mayorSignature, municipalManagerPhoto, municipalManagerSignature, lastPublishedAt, content } = response.data;

    planStore.$patch({ id, subtitle, municipality, logo, coverPageImage, mayorPhoto, mayorSignature, municipalManagerPhoto, municipalManagerSignature, lastPublishedAt });

    // Direct assignment avoids Pinia's deep-merge behaviour in $patch, which would preserve
    // keys from the previous plan's content if the incoming content is missing them (e.g. otherExpenditure).
    planStore.content = content;
  }
};

const loadAnnexures = async () => {
  const response = await useHttp().get(`/municipalities/${route.params.municipality}/plan/annexures`);

  if (response.statusCode === HttpStatusCode.Ok) {
    planStore.planAnnexures = response.data.items;
  }
};

const loadFrameworks = async () => {
  const response = await useHttp().get('/util/frameworks');

  if (response.statusCode === HttpStatusCode.Ok) {
    frameworks.value = response.data.items;
  }
};

onMounted(() => {
  planStore.loading = true;

  Promise
    .all([
      loadPlan(),
      loadFrameworks(),
      loadAnnexures(),
    ])
    .finally(() => {
      planStore.loading = false;
    });
});
</script>
